import cartItem from "./cartItem";
import profileSearchCart from "./profileSearchCart";

export default {
    components:{cartItem,profileSearchCart},
    template: `
<div class="p-cart-content container">
    <div class="text-center" v-if="backed && loading">
                <img class="loading-image" src="{{url('../images/spinner.gif')}}" alt="Loading..." />
    </div>
     <div v-else-if="step === 1">
        <p v-if="enableAddMode && !enableChangeMode">${langhelp.change.change_help}</p>
        <h1 v-if="enableAddMode && enableChangeMode">${langhelp.change.size}</h1>
        <h1 class="text-center" v-else-if="!enableAddMode">${langhelp.change.remove}</h1>
        <h1 class="text-center" v-else>${langhelp.change.change}</h1>
        <p class="text-center">${langhelp.change.remove_items_help}</p>
         <slot name="top">
            <div class="pure-g cart-top d-none d-md-flex">
                <div class="pure-u-1-2">${langhelp.change.product}</div>
                <div class="d-none d-md-block pure-u-md-1-8 text-end">${langhelp.change.price}</div>
                <div class="pure-u-1-4 text-center" v-if="!(enableAddMode && enableChangeMode)">${langhelp.change.quantity}</div>
                <div class="pure-u-1-4 pure-u-md-1-8 text-end" v-if="!(enableAddMode && enableChangeMode)">${langhelp.change.total}</div>
            </div>
        </slot>
          <div class="d-grid d-md-flex pure-g item" v-for="(item,i) in items" :key="item.id"  v-show="item.quantity > 0">
             <slot
                 name="product"
                 :product="item"
                 :quantity="item.quantity"
                 :index="i"
                 :remove="() => removeLocal(i)"
                 :modify-quantity="(qty) => modifyLocalQty({orderItemIndex:i,qty})"
                   :change-variant="(payload) => changeVariant({...payload,change_pvId:payload.change_pvId ?? payload.product_variant_id,orderItemIndex:i})"
                 :show-variants="showVariants"
                 :enable-buttons="true"
             >
                 <cart-item
                     :orderItemIndex="i"
                     :product_name="item.product_name"
                     :image="item.image"
                     :qty="item.quantity"
                     :serial="item.serial"
                      :characteristics="item.characteristics"
                     :product_variant_id="item.product_variant_id"
                     :price="item.price"
                     :enable-add-mode="enableAddMode"
                     :enable-change-mode="enableChangeMode"
                      :variants="item.other_variants"
                     @remove-product="removeLocal"
                     @modify-qty="modifyLocalQty"
                      @change-variant="changeVariant"
                 />
             </slot>
          </div>
                  <div v-if="!enableChangeMode">
                 <h1 class="text-center">${langhelp.change.removed_items}</h1>
                 <p class="text-center">${langhelp.change.removed_items_help}</p>
                 <slot name="top">
                    <div class="pure-g cart-top d-none d-md-flex">
                        <div class="pure-u-1-2">${langhelp.change.product}</div>
                        <div class="d-none d-md-block pure-u-md-1-8 text-end">${langhelp.change.price}</div>
                        <div class="pure-u-1-4 text-center" v-if="!(enableAddMode && enableChangeMode)">${langhelp.change.quantity}</div>
                        <div class="pure-u-1-4 pure-u-md-1-8 text-end" v-if="!(enableAddMode && enableChangeMode)">${langhelp.change.total}</div>
                    </div>
                </slot>
                  <div class="d-grid d-md-flex pure-g item" v-for="(item,i) in removedItems" :key="item.id">
                     <slot
                         name="product"
                         :product="item"
                         :quantity="item.quantity"
                         :index="i"
                         :remove="() => removeLocal(i)"
                         :modify-quantity="(qty) => modifyLocalQty({orderItemIndex:i,qty})"
                          :change-variant="(payload) => changeVariant({...payload,change_pvId:payload.change_pvId ?? payload.product_variant_id,orderItemIndex:i})"
                         :show-variants="false"
                          :enable-buttons="false"
                     >
                         <cart-item
                             :orderItemIndex="i"
                             :product_name="item.product_name"
                             :image="item.image"
                             :qty="item.quantity"
                             :product_variant_id="item.product_variant_id"
                             :price="item.price"
                             :serial="item.serial"
                             :characteristics="item.characteristics"
                             :show-buttons="false"
                             :enable-add-mode="enableAddMode"
                             :enable-change-mode="enableChangeMode"
                             :variants="item.other_variants"
                             @remove-product="removeLocal"
                             @modify-qty="modifyLocalQty"
                             @change-variant="changeVariant"
                         />
                     </slot>
                 </div>
        </div>
        <div v-if="!enableChangeMode">
            <div class="fs-4" v-if="priceDifferentation < 0">
                {{text.refund.replace(':num',priceDifferentation+" "+order.currency_code)}}
            </div>
             <div class="fs-4" v-else>
                {{text.pay.replace(':num',priceDifferentation+" "+order.currency_code)}}
            </div>
        </div>
        <div v-if="error" class="alert alert-danger" role="alert">{{error}}</div>
         <div class="pure-g justify-content-right">
            <button type="button" class="btn btn-primary" v-on:click="nextStep()">${langhelp.next}</button>
        </div>
    </div>
    <div v-else-if="step === 2">
        <div v-show="enableAddMode && !enableChangeMode">
            <h1 class="text-center">${langhelp.change.add}</h1>
            <p class="text-center">${langhelp.change.add_items_help}</p>
            <profile-search-cart @add-to-cart="handleAddToCart"/>
             <div v-if="!enableChangeMode">
                <h1 class="text-center">${langhelp.change.added_items}</h1>
                <p class="text-center">${langhelp.change.added_items_help}</p>
                <div class="d-grid d-md-flex pure-g item" v-for="(item,i) in items.filter((e) => (order.orderItems.find((j) => j.product_variant_id === e.product_variant_id)?.quantity ?? 0) < e.quantity)" :key="item.id">
                     <slot name="product" :product="item" :quantity="item.quantity" :index="i" :remove="() => removeLocal(i)" :modify-quantity="(qty) => modifyLocalQty({orderItemIndex:i,qty})" :change-variant="(payload) => changeVariant({...payload,change_pvId:payload.change_pvId ?? payload.product_variant_id,orderItemIndex:i})" :show-variants="false" :enable-buttons="false">
                         <cart-item :orderItemIndex="i" :product_name="item.product_name" :image="item.image" :qty="item.quantity" :product_variant_id="item.product_variant_id" :price="item.price" :serial="item.serial" :characteristics="item.characteristics" :show-buttons="false" :enable-add-mode="enableAddMode" :enable-change-mode="enableChangeMode" :variants="item.other_variants" />
                     </slot>
                </div>
             </div>
        </div>
        <div v-if="!enableChangeMode">
            <div class="fs-4" v-if="priceDifferentation < 0">
                {{text.refund.replace(':num',priceDifferentation+" "+order.currency_code)}}
            </div>
             <div class="fs-4" v-else>
                {{text.pay.replace(':num',priceDifferentation+" "+order.currency_code)}}
            </div>
        </div>
         <div class="pure-g justify-content-right">
            <button type="button" class="btn btn-link" v-on:click="backStep()">${langhelp.back}</button>
            <button type="button" class="btn btn-primary" v-on:click="nextStep()">${langhelp.next}</button>
        </div>
    </div>
    <div v-else-if="step === 3">
    <div>
                <h1 class="text-center">${langhelp.change.changed_items}</h1>
                <p class="text-center">${langhelp.change.changed_items_help}</p>
                <div class="d-grid d-md-flex pure-g item" v-for="(item,i) in items.filter((e) => (order.orderItems.find((j) => j.product_variant_id === e.product_variant_id)?.quantity ?? 0) != e.quantity)" :key="item.id">
                     <slot name="product" :product="item" :quantity="item.quantity - (order.orderItems.find((j) => j.product_variant_id === item.product_variant_id)?.quantity ?? 0)" :index="i" :remove="() => removeLocal(i)" :modify-quantity="(qty) => modifyLocalQty({orderItemIndex:i,qty})" :change-variant="(payload) => changeVariant({...payload,change_pvId:payload.change_pvId ?? payload.product_variant_id,orderItemIndex:i})" :show-variants="false" :enable-buttons="false">
                         <cart-item :orderItemIndex="i" :product_name="item.product_name" :image="item.image" :qty="item.quantity - (order.orderItems.find((j) => j.product_variant_id === item.product_variant_id)?.quantity ?? 0)" :product_variant_id="item.product_variant_id" :price="item.price" :serial="item.serial" :characteristics="item.characteristics" :show-buttons="false" :enable-add-mode="false" :enable-change-mode="false" :variants="item.other_variants" />
                     </slot>
                </div>
             </div>
        <div v-show="order.delivered_status > 1 || order.accepted > 0">
            <h1 class="text-center" v-else>${langhelp.change.address}</h1>
            <div class="form-group" v-for="(method,i) in deliveryMethods">
                <input
                    :id="'methodShipping-'+i"
                    type="radio"
                    name="methodShipping"
                    @input="deliveryMethod = method.id">
                <label :for="'methodShipping-'+i" class="pure-g">
                    <div class="pure-u">
                        <div>{{method.name}}</div>
                        <div class="text-grey" v-if="priceDifferentationProducts + getDeliveryPrice(method?.price) < 0" class="mr-2">
                            {{text.refund.replace(':num',(priceDifferentationProducts + getDeliveryPrice(method?.price))+" "+order.currency_code)}}
                        </div>
                    </div>
                    <div class="pure-u-auto">
                        <span class="mr-2">
                            {{getDeliveryPrice(method?.price)}} {{order.currency_code}}
                        </span>
                    </div>
                </label>
            </div>
            <div v-show="deliveryMethod && selectedDeliveryMethod.type != 2  && selectedDeliveryMethod.type != 9">
                <h1 class="text-center" v-if="enableAddMode && !enableChangeMode">${langhelp.change.address_change}</h1>
                <h1 class="text-center" v-else>${langhelp.change.address}</h1>
                <div class="form-group" v-for="(ship,i) in order.orderDeliveries.filter((e) => !(e?.package_point?.length ?? 0) > 0)">
                    <input
                        :id="'savedShipping-'+i"
                        type="radio"
                        name="savedShipping"
                        @input="newDeliveryAddress=false;delivery = {country_id:ship.country_id,post_code:ship.post_code,city:ship.city,street:ship.street,house:ship.house,state:ship.state,area:ship.area,package_point:ship.package_point}">
                    <label :for="'savedShipping-'+i" class="pure-g">
                        <div class="pure-u-1">
                            {{ship.post_code}}, {{ship.city}} {{ship.street}} {{ship.house}} {{ship.package_point}}
                        </div>
                    </label>
                </div>
                <div class="form-group">
                    <input
                        id="savedShipping-new"
                        type="radio"
                        name="savedShipping"
                        @input="newDeliveryAddress = true;delivery.package_point = ''">
                    <label for="savedShipping-new" class="pure-g">
                        <div class="pure-u-1">
                            ${langhelp.change.new_address}
                        </div>
                    </label>
                </div>
                <div v-show="newDeliveryAddress" class="pure-g">
                                <div class="pure-u-1-1 pure-u-sm-1-3">
                                    <div class="form-group">
                                        <label for="country">${langhelp.address.country}</label>
                                        <select id="country" v-model="countryShipping" v-on:change="loadPaymentMethods">
                                           <template v-for="country in countries">
                                               <option :value="country">{{country.name}}</option>
                                           </template>
                                        </select>
                                    </div>
                                </div>
                                <div class="pure-u-1-1 pure-u-sm-1-3"  v-show="countryShipping?.need_state == 1">
                                    <div class="form-group">
                                        <label for="state">${langhelp.address.state}</label>
                                        <input id="state" type="text" v-model="delivery.state">
                                    </div>
                                </div>
                                <div class="pure-u-1-1 pure-u-sm-1-3"  v-show="countryShipping?.need_area == 1">
                                    <div class="form-group">
                                        <label for="area">${langhelp.address.area}</label>
                                        <input id="area" type="text" v-model="delivery.area">
                                    </div>
                                </div>
                                <div class="pure-u-1-1 pure-u-sm-1-3"  v-show="countryShipping?.need_post_code == 1">
                                    <div class="form-group">
                                        <label for="post-code">${langhelp.address.post_code}</label>
                                        <input id="post-code" type="text" v-model="delivery.post_code">
                                    </div>
                                </div>
                                <div class="pure-u-1-1 pure-u-sm-1-3">
                                    <div class="form-group">
                                        <label for="town">${langhelp.address.city}</label>
                                        <input id="town" type="text" v-model="delivery.city" >
                                    </div>
                                </div>
                                <div class="pure-u-1-1 pure-u-sm-2-3">
                                    <div class="form-group">
                                        <label for="address">${langhelp.address.street}</label>
                                        <input id="address" type="text" v-model="delivery.street">
                                    </div>
                                </div>
                                <div class="pure-u-1-1 pure-u-sm-1-3">
                                    <div class="form-group" :class="{error:houseError}">
                                        <label for="number">${langhelp.address.house}</label>
                                        <input id="number" type="text" v-model="delivery.house" v-on:change="checkHouse">
                                    </div>
                                </div>
                     </div>
            </div>
            <div v-if="!enableAddMode && !enableChangeMode && !((delivery?.package_point?.length ?? 0) > 0)">
                 <h1 class="text-center" v-if="timesLoading || days?.length > 0">${langhelp.change.pickup_time}</h1>
                 <p v-if="timesLoading || days?.length > 0">${langhelp.change.pickup_time_help}</p>
                <div class="pure-g" v-if="timesLoading">
                    <div class="pure-u-1  pure-u-md-1-4" v-for="i in 4" :key="i">
                        <div class="form-group">
                            <input type="radio" class="skeleton">
                             <label class="pure-g skeleton skeleton-text">
                                <div class="pure-u-1">
                                </div>
                            </label>
                        </div>
                    </div>
                 </div>
                 <div class="pure-g" v-else>
                     <div class="pure-u-1" :class="'pure-u-md-1-'+days?.length" v-for="(day,i) in days" :key="day.date">
                        <div class="form-group">
                            <input
                                :id="'day-'+i"
                                type="radio"
                                name="day"
                                @input="pickupStartTime = day.startTime;pickupEndTime=day.endTime;pickup.date=day.date;">
                            <label :for="'day-'+i" class="pure-g">
                                <div class="pure-u-1">
                                    {{day.date}}
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="max-h-55 scrollable">
                     <div class="form-group" v-for="i in (pickupEndTime - pickupStartTime - 1)" :key="i">
                        <input
                            :id="'time-'+i"
                            type="radio"
                            name="time"
                            @input="pickup.time=pickupStartTime + i">
                        <label :for="'time-'+i" class="pure-g">
                            <div class="pure-u-1">
                                {{pickupStartTime + i - 1}}:00 - {{pickupStartTime + i }}:00
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
         <div  v-if="priceDifferentation>0">
                <h1 class="text-center">${langhelp.payment.payment_methods}</h1>
                <div class="pure-g" v-if="paymentsLoading">
                        <div class="pure-u-1" v-for="i in 4" :key="i">
                            <div class="form-group">
                                <input type="radio" class="skeleton">
                                 <label class="pure-g skeleton skeleton-text">
                                    <div class="pure-u-1">
                                    </div>
                                </label>
                            </div>
                        </div>
                     </div>
                     <div v-else>
                         <div v-for="(payment,i) in payments" :key="payment.id">
                            <div class="form-group">
                                <input
                                    :id="'payment-'+payment.id"
                                    type="radio"
                                    name="payment"
                                    @input="paymentMethod = payment">
                                <label :for="'payment-'+payment.id" class="pure-g">
                                    <div class="pure-u-1">
                                        {{payment.name}}
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                 </div>
                <div>
                <div>
                     <div id="payment-element"></div>
                      <div aria-live="polite">
                            <span v-if="paymentError" class="alert alert-danger" role="alert">@{{paymentError}}</span>
                        </div>
                </div>
            </div>

            <div v-if="enableDisputeMode">
            <h1 class="text-center">${langhelp.help.description}</h1>
              <textarea v-model="disputeText" class="w-100"></textarea>
            </div>
        <div class="fs-6" v-if="deliveryPrice > 0">
            ${langhelp.payment.delivery_price}: {{deliveryPrice}} {{order.currency_code}}
        </div>
        <div class="fs-4" v-if="priceDifferentation < 0">
            {{text.refund.replace(':num',priceDifferentation+" "+order.currency_code)}}
        </div>
         <div class="fs-4" v-else>
            {{text.pay.replace(':num',priceDifferentation+" "+order.currency_code)}}
        </div>
         <div aria-live="polite">
             <div v-if="error" class="alert alert-danger" role="alert">{{error}}</div>
             <span v-if="paymentError" class="alert alert-danger" role="alert">@{{paymentError}}</span>
         </div>
        <div class="pure-g justify-content-right">
             <button type="button" class="btn btn-link" v-on:click="backStep()">${langhelp.back}</button>
            <button type="button" class="btn btn-primary" v-on:click="finishOrder()" :class="{'loading-spin':loading}" :disabled="loading"><span>${langhelp.finish}</span></button>
        </div>
    </div>
</div>
    `,
    props: {
        order:{
            type:Object
        },
        enableAddMode:{
            type:Boolean,
            default:true
        },
        enableChangeMode:{
            type:Boolean,
            default:true
        },
        enableDisputeMode:{
            type:Boolean,
            default:false
        },
        paymentError:{
            type:String
        },
        successfulPayment:{
            type:Boolean,
            default:false
        },
        backed:{
            type:Boolean,
            default:false
        },
        pendingReturn:{
            type:Object,
            default:null
        },
        showVariants:{
            type:Boolean,
            default:true
        },
    },
    data(){
        return {
            text: {
              refund: `${langhelp.payment.refund}`,
              pay: `${langhelp.payment.payment}`
            },
            error: null,
            timesLoading: false,
            localOrderItems:this.transformOrderData(this.order.orderItems),
            productsToAdd:[],
            productsToDel:[],
            delivery: {},
            newDeliveryAddress: false,
            countries: [],
            deliveryMethods: [],
            countryShipping: {},
            loading: false,
            paymentMethod: null,
            houseError: false,
            step: 1,
            paymentsLoading: false,
            payments: [],
            days: [],
            pickupStartTime: 0,
            pickupEndTime: 1,
            deliveryMethod: null,
            pickup: {
                time:null,
                date:null,
            },
            payload: null,
            url: null,
            disputeText: "",
        }
    },
    computed:{
        removedItems(){
            return this.items.filter((e) => (this.order.orderItems.find((j) => j.product_variant_id === e.product_variant_id)?.quantity ?? 0) > e.quantity);
        },
        items(){
            return this.localOrderItems;
        },
        selectedDeliveryMethod(){
            if(!this.deliveryMethod){
                return null;
            }
            return this.deliveryMethods.find((e) => e.id === this.deliveryMethod);
        },
        deliveryPrice() {
            if(this.selectedDeliveryMethod) {
                return this.getDeliveryPrice(this.selectedDeliveryMethod?.price);
            }

            return 0;
        },
        priceDifferentationProducts() {
            let price = 0;
            for (const item of this.items) {
                let d = item.quantity - (this.order.orderItems.find((j) => j.product_variant_id === item.product_variant_id)?.quantity ?? 0);
                price += item.price * d;
            }

            return price;
        },
        priceDifferentation(){
            return this.priceDifferentationProducts + this.deliveryPrice;
        },
        // an exchange: something is added back to the order (productsToAdd)
        isExchange(){
            return this.items.some((item) => item.quantity > (this.order.orderItems.find((j) => j.product_variant_id === item.product_variant_id)?.quantity ?? 0));
        },
    },
    watch: {
        loading(){
          if(this.loading){
              setTimeout(()=> this.loading = false,10000);
          }
        },
        successfulPayment() {
            this.apiCall();
        },
        backed() {
          if(this.url && this.payload) {
            this.apiCall();
          }
        },
        paymentError() {
          this.loading = false;
        },
        paymentMethod() {
            if(this.paymentMethod && this.paymentMethod?.type === 1){
                this.$emit("initPayment",this.order.id,this.paymentMethod.id,this.priceDifferentation);
            }
        },
        delivery(){
            this.loadPickupTimes();
            this.loadPaymentMethods();
        },
        enableAddMode() {
          this.step = 1;
        },
        enableChangeMode() {
          this.step = 1;
        },
        order() {
            this.step = 1;
            this.localOrderItems = this.transformOrderData(this.order.orderItems);
        },
        newDeliveryAddress() {
            if(this.countries.length < 1){
                this.fetchCountries();
            }
        },
        countryShipping() {
            this.delivery.country_id = this.countryShipping.id;
            this.fetchDeliveryMethods();
        }
    },
    mounted() {
        if(this.backed && this.pendingReturn?.url){
            this.url = this.pendingReturn.url;
            this.payload = this.pendingReturn.payload;
            this.apiCall();
        }
    },
    methods:{
        checkHouse(){
            if(this.countryShipping.house_regex !== null && this.countryShipping.house_regex !== undefined){
                let exp = new RegExp(this.countryShipping.house_regex);
                if (!exp.test(this.delivery.house) && (this.selectedDeliveryMethod?.type==1 || this.selectedDeliveryMethod?.type==5)) {
                    this.houseError = true;
                    return;
                }
            }
            this.houseError = false;
            this.loadPickupTimes();
        },
        getDeliveryPrice(prices) {
            // the return parcel of an exchange is free, the backend prices it 0 (OrderManager::deleteProduct)
            if (this.isExchange) {
                return 0;
            }
            let min = null;
            for (const price of prices) {
                if (price.country_id !== undefined && price.country_id !== null && price.country_id != this.delivery.country_id) {
                    continue;
                }
                if (price.min_order_amount > 0 && price.min_order_amount < this.priceDifferentationProducts) {
                    continue;
                }
                if (price.min_order_count  > 0 && price.min_order_count < this.removedItems.length) {
                    continue;
                }
                if (min === null || min.price > price.price) {
                    min = price;
                }
            }

            if(min === null){
                return 0;
            }

            return min.price;
        },
        loadPaymentMethods() {
            this.paymentsLoading = true;
            fetch(
                "/api/payment-methods",
                {
                    method:"POST",
                    headers: http.headers(),
                    body: JSON.stringify(this.delivery),
                }
            )
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    this.payments = data;
                    this.paymentsLoading = false;
                });
        },
        loadPickupTimes() {
            if(this.delivery.method === undefined || this.delivery.method === null){
                this.delivery.method = this.deliveryMethod;
            }
            if(this.delivery.method === undefined || this.delivery.method === null){
                this.delivery.method = this.countryShipping.default_delivery_method;
            }
            this.timesLoading = true;
            this.pickupStartTime = 0;
            this.pickupEndTime = 1;
            fetch(
                "/api/package-pickups",
                {
                    method:"POST",
                    headers: http.headers(),
                    body: JSON.stringify(this.delivery),
                }
            )
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    this.days = data;
                    this.timesLoading = false;
                });
        },
        backStep() {
            if(this.step === 3 && !(this.enableAddMode && !this.enableChangeMode)) {
                this.step = 1;
            }else if(this.step > 1) {
                this.step--;
            }
            if(this.step === 2){
                setTimeout(() => {
                    forms.load();
                }, 100);
            }
        },
        nextStep() {
            if(this.step === 1){
                if(!this.removedItems.length){
                    this.error = 'Please Remove At Least one Item';
                    return;
                }
                this.delivery.country_id = this.order.orderDeliveries.find((e) => !(e?.package_point?.length ?? 0) > 0)?.country_id;
                if(this.delivery.country_id === undefined){
                    this.delivery.country_id = this.order.orderDeliveries[0].country_id;
                }
                this.fetchDeliveryMethods();
            }
            this.error = '';
            if(this.step === 1 && !(this.enableAddMode && !this.enableChangeMode)) {
                this.step = 3;
            }else if(this.step < 3) {
                this.step++;
            }
            if(this.step === 2){
                setTimeout(() => {
                    forms.load();
                }, 100);
            }
            if(this.step === 3 && !(this.order.delivered_status > 1 || this.order.accepted > 0)){
                this.delivery.method = this.order.orderDeliveries[0].delivery_method_id;
                this.loadPaymentMethods();
            }
        },
        async fetchCountries() {
            const response = await fetch(`/api/countries/deliveries`, {
                method: "GET",
                headers: http.headers(),
            });

            if (response.ok) {
                this.countries = await response.json();

                setTimeout(() => forms.load(),200);
            }
        },
        async fetchDeliveryMethods() {
            const response = await fetch(`/api/countries/deliveries/${this.delivery.country_id}/returns`, {
                method: "GET",
                headers: http.headers(),
            });

            if (response.ok) {
                this.deliveryMethods = await response.json();

                setTimeout(() => forms.load(),200);
            }
        },
        transformOrderData(orderItems){
            return  orderItems.map(item=>{
                let product_name="";
                const translation=item.productVariant.product.product_translations.find(trans=>trans.language_code===lan);
                if(translation){
                    product_name=translation.name;
                }

                return {
                    product_variant_id:item.product_variant_id,
                    selected_variant_id:item.product_variant_id,
                    product_name,
                    quantity:item.quantity,
                    price:item.payed_price,
                    currency: this.order.currency_code,
                    serial: item.productVariant.product.serial,
                    characteristics: item.productVariant.characteristics ?? [],
                    image:  item.productVariant.productImages.length > 0 ? item.productVariant.productImages[0]:"",
                    other_variants:item.other_variants
                }

            });
        },
        removeLocal(orderItemIndex){
            this.localOrderItems=this.localOrderItems.map((order,index)=>{
                if(index==orderItemIndex &&  order.quantity >= 1 ){
                    return {...order,quantity:0}
                }
                return order;
            })
        },
        modifyLocalQty(payload){
            this.localOrderItems=this.localOrderItems.map((order,index)=>{
                if(index==payload.orderItemIndex &&  order.quantity >= 1 ){
                    return {...order,quantity:order.quantity+payload.qty}
                }
                return order;
            })
        },

        changeVariant(payload){
            const orderItems=this.localOrderItems;
            if(orderItems[payload.orderItemIndex].other_variants){
                let old = Object.assign({},orderItems[payload.orderItemIndex]);
                old.quantity = 0;
                this.localOrderItems= orderItems.map((orderItem,index)=>{
                    if(index===payload.orderItemIndex){
                        const selectedId = payload.change_pvId ?? payload.product_variant_id;
                        return {
                            ...orderItem,
                            product_variant_id:payload.change_pvId,
                            selected_variant_id:payload.change_pvId,
                             characteristics: payload.characteristics ?? [],
                             other_variants: orderItem.other_variants.map((variant)=>({
                                  ...variant,
                                  is_current: String(variant.product_variant_id) === String(selectedId),
                                  is_original: variant.is_original === true || variant.is_original === 1,
                                  characteristics: variant.characteristics.map((characteristic) => ({
                                     ...characteristic,
                                     is_current: String(variant.product_variant_id) === String(selectedId)
                                 }))
                             }))
                        }
                    }
                    return orderItem;
                })
                this.handleAddToCart(old);
            }
        },
        finishOrder() {
            this.loading = true;
            this.error = "";
            const productsToAdd = [];

            const productsToDel = [];

            if(this.selectedDeliveryMethod !== null && this.selectedDeliveryMethod !== undefined && this.selectedDeliveryMethod.type != 2 && (this.order.delivered_status > 1 || this.order.accepted > 0) && this.pickup.time === null && !this.enableAddMode && !this.enableChangeMode && !((this.delivery?.package_point?.length ?? 0) > 0)){
                this.error = 'Please select a pickup time';
                this.loading = false;
                return;
            }

            if(this.priceDifferentation > 0 && this.paymentMethod === null){
                this.error = 'Please select a payment method';
                this.loading = false;
                return;
            }

            if(this.countryShipping.house_regex !== null && this.countryShipping.house_regex !== undefined){
                let exp = new RegExp(this.countryShipping.house_regex);
                if (!exp.test(this.delivery.house) && (this.selectedDeliveryMethod?.type==1 || this.selectedDeliveryMethod?.type==5)) {
                    this.error = 'Wrong house number!';
                    this.loading = false;
                    return;
                }
            }

            if(this.enableDisputeMode && this.disputeText.length < 20){
                this.error = 'Please fill up the message form with your problem!';
                this.loading = false;
                return;
            }

            this.delivery.method = this.deliveryMethod;

            this.localOrderItems.forEach((local, index) => {
                const orderItems = this.order.orderItems;
                //case for adding new item
                if (!orderItems[index] && local.quantity > 0) {
                    productsToAdd.push({
                        id: local.product_variant_id,
                        quantity: local.quantity
                    })
                }
                //case for changing size
                if (orderItems[index] && orderItems[index].product_variant_id !== local.product_variant_id) {
                    productsToAdd.push({
                        id: local.product_variant_id,
                        quantity: local.quantity
                    })
                    productsToDel.push({
                        id: orderItems[index].product_variant_id,
                        quantity: orderItems[index].quantity
                    })
                }
                //case for increasing qty

                if (orderItems[index] && orderItems[index].product_variant_id === local.product_variant_id && local.quantity > orderItems[index].quantity) {

                    productsToAdd.push({
                        id: local.product_variant_id,
                        quantity: local.quantity - orderItems[index].quantity
                    })
                }
                //case for decreasing qty
                else if (orderItems[index] && orderItems[index].product_variant_id === local.product_variant_id && local.quantity < orderItems[index].quantity) {

                    productsToDel.push({
                        id: local.product_variant_id,
                        quantity: orderItems[index].quantity - local.quantity
                    })
                }
            });
            let url = `/api/orders/item/${this.order.id}/change`
            let payload = {
                operation: 'change',
                productsToAdd,
                productsToDel,
                token: Cookies.getItem('login_token'),
                delivery: this.delivery
            }

            if (!productsToDel.length) {
                this.error = 'Please Remove At Least one Item';
                this.loading = false;
                return;
            }
            if (productsToDel.length && !productsToAdd.length) {
                payload = {
                    operation: 'delete',
                    productsToDel,
                    token: Cookies.getItem('login_token'),
                    delivery: this.delivery
                };
                url = `/api/orders/item/${this.order.id}/remove`
            }

            if (this.pickup.date !== null) {
                payload.pickup = this.pickup;
            }


            if(this.enableDisputeMode){
                payload.dispute_message = this.disputeText;
            }

            this.url = url;
            this.payload = payload;

            if (this.paymentMethod && this.paymentMethod?.type === 1) {
                this.$emit("callFinishPayment");
            }else if(this.priceDifferentation < 0) {
                this.$emit('refund', {url: this.url, payload: this.payload});
            }else{
                this.apiCall();
            }
        },
        apiCall() {
            //hit api
            this.loading = true;
            fetch(this.url,{
                method:"POST",
                headers:http.headers(),
                body: JSON.stringify(this.payload),
            })
                .then(res=>{
                    return res.json();
                })
                .then(data=>{
                    this.step = 3;
                    this.loading = false;
                    if(!data.success){
                        this.error = typeof data?.error === 'string' ? data?.error : "Something Went Wrong";
                        return;
                    }
                    this.$emit('success');
                })
                .catch(err=>{
                    this.loading = false;
                    console.log(err);
                });
        },
        handleAddToCart(item){
            //edge case what if the user added the item which are already in the cart
            const findPdVariantInCartIndex=this.localOrderItems.findIndex(local=>local.product_variant_id===item.product_variant_id)

            if(findPdVariantInCartIndex >= 0){
                this.localOrderItems=this.localOrderItems.map((local,index)=>{
                    if(local.product_variant_id===item.product_variant_id){
                        return {
                            ...local,
                            quantity:local.quantity+item.quantity
                        }
                    }
                    return local;
                })
            }else{
                //append to last array
                this.localOrderItems=[...this.localOrderItems,item]
            }
        }
    }
};
